export const validationLogin = (value: { email: string, password: string }) => {
    console.log("value", value);

    const errors: { email: string; password: string } = {
        email: "",
        password: "",
    };

    // Check email
    if (!value.email.trim()) {
        errors.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value.email)) {
        errors.email = "Invalid email format";
    }

    // Check password
    if (!value.password.trim()) {
        errors.password = "Password is required";
    } else if (value.password.length < 8) {
        errors.password = "Password must be at least 8 characters";
    }

    return errors;
};

export function isValidURL(str: string) {
    const pattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;
    return pattern.test(str);
}

export const getImageDimensions = (file: any) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        });
        URL.revokeObjectURL(url);
      };

      img.onerror = () => {
        reject(new Error('Could not load image'));
        URL.revokeObjectURL(url);
      };

      img.src = url;
    });
  };